/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrtimesMediaListCheckConflictRequest
 */
export interface PrtimesMediaListCheckConflictRequest {
    /**
     * フロントエンドで保持しているメディアリストの最終更新日(Y-m-d\TH:i:sP)
     * @type {string}
     * @memberof PrtimesMediaListCheckConflictRequest
     */
    lastEditTime: string;
}

export function PrtimesMediaListCheckConflictRequestFromJSON(json: any): PrtimesMediaListCheckConflictRequest {
    return PrtimesMediaListCheckConflictRequestFromJSONTyped(json, false);
}

export function PrtimesMediaListCheckConflictRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrtimesMediaListCheckConflictRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lastEditTime': json['last_edit_time'],
    };
}

export function PrtimesMediaListCheckConflictRequestToJSON(value?: PrtimesMediaListCheckConflictRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'last_edit_time': value.lastEditTime,
    };
}

